// --------------------------------------------------------------------------
// #129 Postcode Hero
//     - handles validation for postcode
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

// jquery plugins
require('../../plugins/jquery.validate');
require('../../plugins/jquery.validate.unobtrusive');

module.exports = function () {

    function init() {

        $('.postcode-hero__form').validate({
            errorClass: 'field-validation-error',
            rules: {
                Postcode: {
                    required: true,
                    postcodeUK: true
                }
            },
            messages: {
                Postcode: {
                    required: 'Please enter a postcode'
                }
            }
        });

        $.validator.addMethod('postcodeUK', function (value, element) {
            return this.optional(element) || /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test(value);
        }, 'Oops! We couldn\'t find that UK postcode. Can you check it\'s correct?');
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/personal-plan/personal-plan-postcode-hero.js
// module id = 252
// module chunks = 0